import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { FullPageLoader } from '@/shared/ui/Feedback';
import { InlineError } from '@/shared/ui/Feedback';
import { useSession } from './session';

function SessionFailure({ error, retry }: { error: unknown; retry: () => void }) {
  return (
    <main className="center-page">
      <InlineError
        error={error}
        action={
          <button className="button button-primary" onClick={retry}>
            Thử lại
          </button>
        }
      />
    </main>
  );
}

export function CustomerGuard() {
  const location = useLocation();
  const session = useSession();

  if (session.isPending) return <FullPageLoader label="Đang kiểm tra phiên đăng nhập" />;
  if (session.isError)
    return <SessionFailure error={session.error} retry={() => void session.refetch()} />;
  if (!session.data) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (session.data.requiresProfile && location.pathname !== '/complete-profile') {
    return <Navigate to="/complete-profile" replace />;
  }
  return <Outlet />;
}

export function AdminGuard() {
  const location = useLocation();
  const session = useSession();

  if (session.isPending) return <FullPageLoader label="Đang xác minh quyền quản trị" />;
  if (session.isError)
    return <SessionFailure error={session.error} retry={() => void session.refetch()} />;
  if (!session.data) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (session.data.requiresProfile) return <Navigate to="/complete-profile" replace />;
  if (session.data.account.role !== 'ADMIN') return <Navigate to="/" replace />;
  return <Outlet />;
}

export function GuestGuard() {
  const session = useSession();
  if (session.isPending) return <FullPageLoader label="Đang tải" />;
  if (session.isError)
    return <SessionFailure error={session.error} retry={() => void session.refetch()} />;
  if (session.data) {
    const destination = session.data.requiresProfile
      ? '/complete-profile'
      : session.data.account.role === 'ADMIN'
        ? '/admin'
        : '/';
    return <Navigate to={destination} replace />;
  }
  return <Outlet />;
}
